import { storage } from '@/utils/storage'

const STORAGE_KEY = 'pending_location_aliases'

export function loadPendingAliases() {
  try {
    const raw = storage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : []
  } catch (e) {
    return []
  }
}

export function savePendingAliases(list) {
  try {
    storage.setItem(STORAGE_KEY, JSON.stringify(list))
  } catch (e) {}
}

export function addPendingAlias(alias) {
  if (!alias) return
  const list = loadPendingAliases()
  if (list.some(x => x.alias === alias)) return
  list.push({ alias, addedAt: Date.now() })
  savePendingAliases(list)
}

export function clearPendingAliases() {
  try {
    storage.removeItem(STORAGE_KEY)
  } catch (e) {}
}
